import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Plumgoodess',
        projectDesc: 'Skin care should be a joyful, nice treat for your skin to restore and maintain your skin at its natural best.',
        tags: ['HTML', 'CSS', 'API','JavaScript'],
        code: 'https://github.com/Noobdev008/Plum_Clone',
        demo: 'https://plumgoodness.netlify.app/',
        image: one
    },
    {
        id: 2,
        projectName: 'MyGlamm',
        projectDesc: 'MyGlamm is a direct-to-consumer beauty brand that offers an online beauty products marketplace with international spa and salon products',
        tags: ['HTML','CSS','JavaScript','MongoDB'],
        code: 'https://github.com/Noobdev008/MyGlamm--Backend',
        demo: 'https://myglammm.netlify.app/',
        image: two
    },
   
    {
        id: 3,
        projectName: 'Covid Tracker',
        projectDesc: 'Coronavirus disease (COVID-19) is an infectious disease caused by the SARS-CoV-2 virus. "In this App the data shows excatly live cases in India".',
        tags: ['React', 'API'],
        code: 'https://github.com/Noobdev008/CovidTracker_react.js',
        demo: 'https://covidtracker-chi.vercel.app/',
        image: three
    },
    {
        id: 4,
        projectName: '',
        projectDesc: '',
        tags: ['', '', '',''],
        code: '',
        demo: '',
        image: four
    },
    {
        id: 5,
        projectName: '',
        projectDesc: '',
        tags: [''],
        code: '',
        demo: '',
        image: five
    },
    {
        id: 6,
        projectName: '',
        projectDesc: '',
        tags: [''],
        code: '',
        demo: '',
        image: six
    },
    {
        id: 7,
        projectName: '',
        projectDesc: '',
        tags: [''],
        code: '',
        demo: '',
        image: seven
    },
    {
        id: 8,
        projectName: '',
        projectDesc: '',
        tags: [''],
        code: '',
        demo: '',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/